const ZURICH_TIMEZONE = 'Europe/Zurich';
const MS_PER_DAY = 24 * 60 * 60 * 1000;

function getStartOfDayInZurich(date: Date): Date {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: ZURICH_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const zurichDateStr = formatter.format(date);
  const [year, month, day] = zurichDateStr.split('-').map(Number);

  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
}

/**
 * Returns the number of whole calendar days between a date and a reference date in Zurich time.
 *
 * Both dates are normalized to the start of their Zurich calendar day before the difference is
 * calculated, so Aug 14 23:59 and Aug 15 00:01 count as 1 day apart rather than 0.
 *
 * @param date - The past date to measure from
 * @param referenceDate - The date to measure against (defaults to now)
 * @returns The number of calendar days since `date`, floored and never negative
 */
export function getCalendarDaysSince(
  date: string | Date,
  referenceDate: Date = new Date(),
): number {
  const parsed = date instanceof Date ? date : new Date(date);
  const dateStartOfDay = getStartOfDayInZurich(parsed);
  const referenceStartOfDay = getStartOfDayInZurich(referenceDate);

  return Math.max(
    0,
    Math.floor((referenceStartOfDay.getTime() - dateStartOfDay.getTime()) / MS_PER_DAY),
  );
}
